import { render } from "./declare_all_done.vue?vue&type=template&id=e23be18a"
import script from "./declare_all_done.vue?vue&type=script&lang=js"
export * from "./declare_all_done.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/beta/web_head/releases/20260131003634/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__